module.exports = __webpack_public_path__ + "img/wallet-02.92100fa8.svg";